import { languageDisplayLabel, LanguagesEnum } from '@/api/enums';

export const availableLanguages = [
  LanguagesEnum.EN,
  LanguagesEnum.DK,
  LanguagesEnum.SE,
  LanguagesEnum.DE,
  LanguagesEnum.NL,
  LanguagesEnum.NO,
];

export const phishingContentLanguages = [
  LanguagesEnum.EN,
  LanguagesEnum.DK,
  LanguagesEnum.DE,
];

export const aiCustomizationLanguages = [
  LanguagesEnum.EN,
  LanguagesEnum.DK,
  LanguagesEnum.SE,
  LanguagesEnum.DE,
  LanguagesEnum.NL,
  LanguagesEnum.NO,
];

export const learnerOnlyLanguages = [
  LanguagesEnum.SE,
  LanguagesEnum.NL,
  LanguagesEnum.NO,
];

export const adminOnlyLanguages = availableLanguages.filter(
  (lang: LanguagesEnum) => !learnerOnlyLanguages.includes(lang),
);

// When redundant just clear the array, so it can be reused for future new languages.
export const courseOnlyLanguages: LanguagesEnum[] = [];

export const availableLanguagesDropdown = availableLanguages
  .map((language: LanguagesEnum) => ({
    label: languageDisplayLabel[language],
    value: language,
  }))
  /* 
    Exception for Kalaallisut (Greenland) and  French.
    Note: This should be used only in user/account/system email context and does not have UI translations.
  */
  .concat([
    {
      label: languageDisplayLabel[LanguagesEnum.KL],
      value: LanguagesEnum.KL,
    },
    {
      label: languageDisplayLabel[LanguagesEnum.FR],
      value: LanguagesEnum.FR,
    },
  ]);

export const keycloakLanguages = {
  [LanguagesEnum.EN]: { label: 'English', value: 'en' },
  [LanguagesEnum.DK]: { label: 'Dansk', value: 'da' },
  [LanguagesEnum.SE]: { label: 'Svenska', value: 'sv' },
  [LanguagesEnum.DE]: { label: 'Deutsch', value: 'de' },
  [LanguagesEnum.NL]: { label: 'Nederlands', value: 'nl' },
  [LanguagesEnum.NO]: { label: 'Norsk', value: 'no' },
};

export const rtlLanguages = [
  LanguagesEnum.AR,
  LanguagesEnum.HE,
  LanguagesEnum.FA,
  LanguagesEnum.UR,
];
